<template>
  <div class="modal-overlay web-auth-modal" v-if="visible" @click.self="close">
    <div class="modal-box">
      <div class="auth-box">
        <div class="logo"><div class="logo-icon"><img :src="logoImg" alt="logo" class="logo-icon-img" /></div><h1>修改交易密码</h1><p class="sub">验证码将发送至您的注册邮箱</p></div>
        <div class="form-group"><label>验证邮箱</label><div class="input-wrap"><input type="email" :value="email" readonly></div></div>
        <div class="form-group"><label>邮箱验证码</label><div class="input-wrap"><input type="text" v-model="form.code" placeholder="请输入验证码" maxlength="6"><button type="button" class="btn-code" @click="sendCode" :disabled="codeCooldown > 0">{{ codeCooldown > 0 ? codeCooldown + 's' : '获取验证码' }}</button></div></div>
        <div class="form-group"><label>新交易密码</label><div class="input-wrap pwd-wrap"><input :type="showPwd ? 'text' : 'password'" v-model="form.newPwd" placeholder="6 位数字" maxlength="6"><span class="pwd-eye" @click="showPwd = !showPwd">{{ showPwd ? '🙈' : '👁' }}</span></div></div>
        <div class="form-group"><label>确认交易密码</label><div class="input-wrap pwd-wrap"><input :type="showPwd ? 'text' : 'password'" v-model="form.confirmPwd" placeholder="再次输入" maxlength="6"><span class="pwd-eye" @click="showPwd = !showPwd">{{ showPwd ? '🙈' : '👁' }}</span></div></div>
        <button class="btn-primary" @click="doChange">确认修改</button>
      </div>
      <div style="text-align:center;margin-top:12px"><a href="javascript:void(0)" @click="close" style="color:#999;font-size:13px;text-decoration:none">关闭</a></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { showToast } from '@/utils/common'
import { sendEmailCode } from '@/api/auth'
import { changeTradePwd } from '@/api/user'

export default {
  name: 'ChangeTradePwdModal',
  props: { visible: Boolean },
  data() { return { logoImg: require('@/assets/logo/logo-icon.png'), form: { code: '', newPwd: '', confirmPwd: '' }, showPwd: false, codeCooldown: 0, sending: false, submitting: false } },
  computed: { ...mapState('user', ['email']) },
  methods: {
    close() { this.$emit('close') },
    async sendCode() {
      if (this.codeCooldown > 0 || this.sending) return
      this.sending = true
      try {
        await sendEmailCode({ email: this.email, scene: 'change_trade_password' })
        this.codeCooldown = 60
        const t = setInterval(() => { this.codeCooldown--; if (this.codeCooldown <= 0) clearInterval(t) }, 1000)
        showToast('验证码已发送')
      } catch (e) {
        showToast(e.message || '发送验证码失败')
      } finally {
        this.sending = false
      }
    },
    async doChange() {
      if (!this.form.code) return showToast('请输入验证码')
      if (!this.form.newPwd || !/^\d{6}$/.test(this.form.newPwd)) return showToast('新交易密码为6位数字')
      if (this.form.newPwd !== this.form.confirmPwd) return showToast('两次密码不一致')
      if (this.submitting) return
      this.submitting = true
      try {
        await changeTradePwd({ email: this.email, code: this.form.code, newTradePassword: this.form.newPwd, confirmTradePassword: this.form.confirmPwd })
        showToast('交易密码修改成功')
        this.close()
      } catch (e) {
        showToast(e.message || '修改失败')
      } finally {
        this.submitting = false
      }
    }
  },
  watch: { visible(v) { if (v) { this.form = { code: '', newPwd: '', confirmPwd: '' }; this.showPwd = false; this.codeCooldown = 0 } } }
}
</script>

<style lang="scss" scoped>
.web-auth-modal .modal-box { width: 420px; padding: 32px 40px; }
.auth-box { width: 100%; }
.auth-box .logo { text-align: center; margin-bottom: 32px; }
.auth-box .logo-icon { width: 56px; height: 56px; background: transparent; border-radius: 14px; margin: 0 auto 12px; display: flex; align-items: center; justify-content: center; }
.auth-box .logo-icon-img { width: 56px; height: 56px; }
.auth-box h1 { font-size: 22px; text-align: center; }
.auth-box .sub { text-align: center; color: var(--text-secondary); font-size: 13px; margin-top: 4px; }
.btn-primary { width: 100%; padding: 12px; background: var(--red); color: #fff; border: none; border-radius: 6px; font-size: 15px; font-weight: 600; cursor: pointer; font-family: inherit; &:hover { opacity: .92; } }
.btn-code { flex-shrink: 0; padding: 0 14px; height: 42px; border: none; background: var(--red-soft); color: var(--red); font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; &:disabled { color: var(--text-muted); cursor: not-allowed; } }
.pwd-wrap { position: relative; }
.pwd-wrap input { padding-right: 36px; }
.pwd-eye { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer; font-size: 16px; user-select: none; }
</style>
